<div class="wizard-step" *ngIf="currentStep === 'EVENTINFO'">
    <div class="page-sub-title">New Event</div>
    <form #form="ngForm" class="form">
        <div class="field">
            <input type="text" name="eventName" required [(ngModel)]="createGolfEventRequest.eventName" #eventNameModel="ngModel" name="eventName" placeholder=" " />
            <label>Event Name</label>
            <span class="error" *ngIf="eventNameModel.invalid && eventNameModel.touched">
                Event Name is required
            </span>
        </div>
        <div class="field">
            <textarea name="eventDescription" required [(ngModel)]="createGolfEventRequest.description" #eventDescriptionModel="ngModel" name="eventDescription" placeholder=" "></textarea>
            <label>Event Details</label>
            <span class="error" *ngIf="eventDescriptionModel.invalid && eventDescriptionModel.touched">
                Details are required
            </span>
        </div>
        <div class="field">
            <input
            type="date"
            name="startDate"
            required
            [(ngModel)]="createGolfEventRequest.startDate"
            #startDateModel="ngModel"
            />
            <label class="static">Event Start Date</label>
            <span class="error" *ngIf="startDateModel.invalid && startDateModel.touched">
                Start Date is required
            </span>
        </div>
        <div class="field">
            <input
            type="date"
            name="endDate"
            required
            [(ngModel)]="createGolfEventRequest.endDate"
            #endDateModel="ngModel"
            />
            <label class="static">Event End Date</label>
            <span class="error" *ngIf="endDateModel.invalid && endDateModel.touched">
                End Date is required
            </span>
        </div>
        <div class="field">
            <input type="text" name="entryFee" required [(ngModel)]="createGolfEventRequest.entryFee" #entryFeeModel="ngModel" name="entryFee" placeholder=" " />
            <label>Entry Fee</label>
            <span class="error" *ngIf="entryFeeModel.invalid && entryFeeModel.touched">
                Entry fee required
            </span>
        </div>
        <div class="field">
            <input
                type="text"
                name="firstPlacePrizeMoney"
                required
                pattern="^[0-9]+(\.[0-9]{1,2})?$"
                [(ngModel)]="createGolfEventRequest.firstPlacePrizeMoney"
                #firstPlaceModel="ngModel"
                placeholder=" "
            />
            <label>First Place Prize</label>
            <span class="error" *ngIf="firstPlaceModel.invalid && firstPlaceModel.touched">
                Valid amount required
            </span>
        </div>
        <div class="field">
            <input
                type="text"
                name="secondPlacePrizeMoney"
                required
                pattern="^[0-9]+(\.[0-9]{1,2})?$"
                [(ngModel)]="createGolfEventRequest.secondPlacePrizeMoney"
                #secondPlaceModel="ngModel"
                placeholder=" "
            />
            <label>Second Place Prize</label>
            <span class="error" *ngIf="secondPlaceModel.invalid && secondPlaceModel.touched">
                Valid amount required
            </span>
        </div>
        <div class="field">
            <input
                type="text"
                name="thirdPlacePrizeMoney"
                required
                pattern="^[0-9]+(\.[0-9]{1,2})?$"
                [(ngModel)]="createGolfEventRequest.thirdPlacePrizeMoney"
                #thirdPlaceModel="ngModel"
                placeholder=" "
            />
            <label>Third Place Prize</label>
            <span class="error" *ngIf="thirdPlaceModel.invalid && thirdPlaceModel.touched">
                Valid amount required
            </span>
        </div>
    </form>
    <button (click)="moveToStep('PLAYERSELECT')">Next</button>
</div>
<div class="wizard-step" *ngIf="currentStep === 'PLAYERSELECT'">
    <div class="page-sub-title">Select Field</div>
    <div class="checkbox-list">
        <label class="checkbox-item" *ngFor="let p of field">
            <input
            type="checkbox"
            [(ngModel)]="p.isSelected"
            name="player-{{ p.player.id }}"
            />
            <span class="checkbox-label">
            {{ p.player.firstName }} {{ p.player.lastName }}
            </span>
        </label>
    </div>
    <button (click)="moveToStep('EVENTINFO')">Back</button>
    <button (click)="moveToStep('REVIEW')">Next</button>
</div>
<div class="wizard-step" *ngIf="currentStep === 'REVIEW'">
    <div class="page-sub-title">Review</div>
    <div *ngFor="let p of getFinalField()">
        {{p.player.firstName}} {{p.player.lastName}}
    </div>
    <button (click)="save()">Save Event</button>
</div>

